var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "extra-user" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.extraEmail.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("E-mailadres")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraEmail,
                    expression: "extraEmail"
                  }
                ],
                attrs: { type: "text", placeholder: "Isadegroot@dubline.nl" },
                domProps: { value: _vm.extraEmail },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraEmail = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraEmail.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("E-mailadres")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.extraEmail.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraEmail,
                    expression: "extraEmail"
                  }
                ],
                attrs: { type: "text", placeholder: "Isadegroot@dubline.nl" },
                domProps: { value: _vm.extraEmail },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraEmail = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraEmail.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.extraPassword.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("Wachtwoord")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraPassword,
                    expression: "extraPassword"
                  }
                ],
                attrs: { type: "password", placeholder: "********" },
                domProps: { value: _vm.extraPassword },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraPassword = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraPassword.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Wachtwoord")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.extraPassword.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraPassword,
                    expression: "extraPassword"
                  }
                ],
                attrs: { type: "password", placeholder: "********" },
                domProps: { value: _vm.extraPassword },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.extraPassword = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.extraPassword.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row row-button row-button--bottom" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c(
          "button",
          {
            staticClass: "button",
            on: {
              click: function($event) {
                return _vm.requestExtraNumber()
              }
            }
          },
          [_vm._v("Aanvragen")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Extra gebruiker")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info col" }, [
      _c("p", [
        _vm._v(
          "\n      Na de aanvraag wordt de extra gebruiker zo snel mogelijk\n      toegevoegd aan het account, dit duurt maximaal 15 minuten.\n      De nieuwe gebruiker  ontvangt een e-mail als zijn account is opgeleverd.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("LET OP!")]),
        _c("br"),
        _vm._v(
          "\n      De kosten van een bundel lopen per maand, dus of je op de eerste\n      of de laatste dag van de maand een bundel aanzet maakt niet\n      uit je betaalt altijd hetzelfde bedrag.\n      "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f672e13c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f672e13c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundles/ExtraUserRequest.vue
// module id = null
// module chunks = 